import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import moment from 'moment';
import Pagination from 'components/v2/Pagination';
import Spinner from 'components/ui/Spinner';

const Loading = function () {
  return (
    <div
      data-testid="div-4479fb1d"
      className="absolute justify-center w-full"
      style={{ top: '50%' }}>
      <div data-testid="div-71c77b0c" className="align-middle">
        <span data-testid="span-49e1ecfd" className="text-5xl text-green">
          <Spinner dataTestId="Spinner-c9a1ec65" showMessage={false} />
        </span>
      </div>
    </div>
  );
};

export default function LaneRateAuditTable({
  items,
  perPage,
  page,
  pages,
  total,
  onPageClick,
  loading,
}) {
  const { t } = useTranslation();

  function handlePageClick(selectedPage) {
    onPageClick(selectedPage);
  }

  function renderHeader(title) {
    return (<div data-testid="div-f3c0cc37" className="flex whitespace-nowrap">{t(title)}</div>);
  }

  function renderLane(item) {
    return (
      <div data-testid="div-740059c0" className="flex flex-col whitespace-nowrap">
        <p data-testid="p-0d7de4f9">
          <b data-testid="b-2334ac32">{titleize(t('ORIGIN'))}:</b> {item.originCity} - {item.originZip}
        </p>
        <p data-testid="p-faff1176">
          <b data-testid="b-f594ae35">{titleize(t('DESTINATION'))}:</b> {item.destinationCity} - {item.destinationZip}
        </p>
      </div>
    );
  }

  function renderTimestamp(createdAt) {
    if (!createdAt || !moment(createdAt).isValid()) {
      return t('INVALID_DATE');
    }
    return moment(createdAt).format('YYYY-MM-DD HH:mm:ss');
  }

  if (loading) {
    return Loading();
  }

  return (
    <div data-testid="div-31ef48de" className="overflow-x-auto w-full">
      <table data-testid="table-d68d9e75" className="default-table w-full">
        <thead data-testid="thead-7391e5be">
          <tr data-testid="tr-065f06d6">
            <th data-testid="th-bede4656">{renderHeader('CUSTOMER')}</th>
            <th data-testid="th-d102ea67">{renderHeader('LANE')}</th>
            <th data-testid="th-e9cd222c">{renderHeader('EVENT')}</th>
            <th data-testid="th-b330f606">{renderHeader('TIMESTAMP')}</th>
            <th data-testid="th-0c7402f0">{renderHeader('SOURCE')}</th>
          </tr>
        </thead>
        <tbody data-testid="tbody-ace833e3">
          {items.map((item, i) => {
            return (
              (<tr
                data-testid={`tr-b00480cd-${i}`}
                key={i}
                className={i === items.length - 1 ? 'border-b' : ''}>
                <td data-testid={`td-bae37c5a-${i}`}>{item.customer}</td>
                <td data-testid={`td-361ffe26-${i}`}>{renderLane(item)}</td>
                <td data-testid={`td-1eb0d976-${i}`}>{item.message}</td>
                <td data-testid={`td-5621a47f-${i}`}>{renderTimestamp(item.createdAt)}</td>
                <td data-testid={`td-4012b4e7-${i}`}>{item.user}</td>
              </tr>)
            );
          })}
        </tbody>
      </table>
      <Pagination
        dataTestId="Pagination-443d293c"
        className="border-none"
        perPage={perPage}
        page={page}
        pages={pages}
        total={total}
        showCount
        paginationContainerClassName="mx-auto my-0 sticky right-2/4"
        onPageClick={handlePageClick} />
    </div>
  );
}
